import { FieldSelect } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { useSchedules } from 'components/settings/components/sections/openingHours/utils/useSchedules';

type Props = {
  label?: string | null;
  error?: string | null;
  onChange: (scheduleId?: string) => void;
  value: string;
};

export function ScheduleSelect({
  label = 'Schedule',
  error,
  onChange,
  value,
}: Props): JSX.Element {
  const {
    currentPageSchedules,
    hasNextPage,
    hasPreviousPage,
    nextPage,
    previousPage,
  } = useSchedules();

  const schedules = currentPageSchedules.map(({ id, name }) => ({
    id,
    name,
  }));

  const handleNextPage = useCallback((): Promise<void> => {
    return Promise.resolve(nextPage());
  }, [nextPage]);

  const handlePreviousPage = useCallback((): Promise<void> => {
    return Promise.resolve(previousPage());
  }, [previousPage]);

  return (
    <FieldSelect
      clearable
      emptyMessage="Select a schedule"
      placeholder="Select a schedule"
      label={label}
      meta={{ error }}
      input={{
        name: 'schedule',
        value,
        onChange,
      }}
      items={schedules}
      pagination={{
        nextEnable: hasNextPage,
        previousEnable: hasPreviousPage,
        onNext: handleNextPage,
        onPrevious: handlePreviousPage,
      }}
    />
  );
}
